import React from 'react';
import { Data } from '../../types/data-providers';
import { useData, dataFromDataset } from './DataProviderCache';
import * as ChartManager from '../domain/chart-manager';
import { useAuthHelper } from '../../components/AuthContextProvider';
import { LoadGraphData } from '../../types/device';

type ContextState = Data<LoadGraphData>;
const Context = React.createContext<ContextState | null>(null);

function useLoadGraphDetails(): ContextState {

    const contextState = React.useContext(Context);
    if (contextState === null) {
        throw new Error('useLoadGraphDetails  details must be used within a Load Graph');
    }

    return contextState;
};

const LoadGraphDataProvider: React.FC<{ deviceId: string }> = (props) => {

    const authHelper = useAuthHelper();
    const { dataset } = useData({
        cacheKey: 'load-graph',
        id: props.deviceId,
        dataFn: React.useCallback(() => ChartManager.getLoadGraphProperities(authHelper, props.deviceId), [
            authHelper,
            props.deviceId,
        ])
    });
    const loadGraphData = dataFromDataset(dataset);
  
    return <Context.Provider value={loadGraphData}>{props.children}</Context.Provider>;
};
const TestLoadGraphDataProvider: React.FC<{ value: ContextState }> = (props) => (
    <Context.Provider value={props.value}>{props.children}</Context.Provider>
);

export { TestLoadGraphDataProvider, LoadGraphDataProvider, useLoadGraphDetails };
